import { render, staticRenderFns } from "./create-feedback.vue?vue&type=template&id=d6895af4&scoped=true&"
import script from "./create-feedback.vue?vue&type=script&lang=js&"
export * from "./create-feedback.vue?vue&type=script&lang=js&"
import style0 from "./create-feedback.vue?vue&type=style&index=0&id=d6895af4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6895af4",
  null
  
)

export default component.exports